import { IconButton, Stack, Tooltip } from "@mui/material";
import EditIcon from "src/assets/svg-icons/admin/edit.svg";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import AddPackagePopup from "../add-package-popup";
import AddEditBranch from "../add-edit-branch";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useNavigate, useParams } from "react-router-dom";

const TableActions = ({
  branchId,
  packageId,
  refetch,
  row,
}: {
  branchId: number;
  packageId: number;
  refetch: Function;
  row: any;
}) => {
  const { t } = useTranslation("general");
  const navigate = useNavigate();
  const { id } = useParams();
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openPackageModal, setOpenPackageModal] = useState(false);

  const handleOpenEditModal = () => setOpenEditModal(true);
  const handleCloseEditModal = () => setOpenEditModal(false);

  const handleOpenPackageModal = () => setOpenPackageModal(true);
  const handleClosePackageModal = () => setOpenPackageModal(false);

  const navigateToBranchDetails = () => {
    navigate(`/customers/${id}/${branchId}`);
  };

  return (
    <Stack direction={"row"} spacing={"12px"} width={"100%"}>
      <Tooltip title={t("edit")} onClick={handleOpenEditModal}>
        <IconButton>
          <img src={EditIcon} alt="" />
        </IconButton>
      </Tooltip>

      <Tooltip title={t("package")} onClick={handleOpenPackageModal}>
        <IconButton>
          <LinkOutlinedIcon sx={{ fontSize: "22px" }} />
        </IconButton>
      </Tooltip>

      <Tooltip title={t("details")}>
        <IconButton>
          <VisibilityOutlinedIcon
            fontSize="small"
            onClick={navigateToBranchDetails}
          />
        </IconButton>
      </Tooltip>

      {openPackageModal && (
        <AddPackagePopup
          branchId={branchId}
          packageId={packageId}
          open={openPackageModal}
          handleClose={handleClosePackageModal}
          refetch={refetch}
        />
      )}

      {openEditModal && (
        <AddEditBranch
          open={openEditModal}
          handleClose={handleCloseEditModal}
          row={row}
          refetch={refetch}
        />
      )}
    </Stack>
  );
};
export default TableActions;
